// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import nwsEntity from './entities/nws.json';
import nwsMenu from '../pages/nws/menu.json';
import nwsFullForm from '../pages/nws/forms/full.json';
import nwsContextForm from '../pages/nws/forms/context.json';
import nwsMiniForm from '../pages/nws/forms/mini.json';
import nwsLookupForm from '../pages/nws/forms/lookup.json';
import nwsTableView from '../pages/nws/views/table.json';
import nwsStagesView from '../pages/nws/views/stages.json';
import nwsCardsView from '../pages/nws/views/cards.json';
import nwsInlineView from '../pages/nws/views/inline.json';
import nwsBacklogView from '../pages/nws/views/backlog.json';
import nwsSplitView from '../pages/nws/views/split.json';
import nwsCalendarView from '../pages/nws/views/calendar.json';
import nwsDashboardView from '../pages/nws/views/dashboard.json';

/** Тип запису «Розсилка» зі сторінками пакета: меню, форми та подання з pages/nws/. */
export const nwsDefinition: IRecordTypeDefinition = {
  ...nwsEntity,
  views: assembleViewSet({
      table: nwsTableView,
      stages: nwsStagesView,
      cards: nwsCardsView,
      inline: nwsInlineView,
      backlog: nwsBacklogView,
      split: nwsSplitView,
      calendar: nwsCalendarView,
      dashboard: nwsDashboardView,
  }),
  form: nwsFullForm,
  forms: { full: nwsFullForm, context: nwsContextForm, mini: nwsMiniForm, lookup: nwsLookupForm },
  menu: nwsMenu,
} as IRecordTypeDefinition;
